














import Vue from 'vue';
import { defineComponent, reactive, inject, watchEffect, computed } from '@vue/composition-api';
import { WokDataGridConfiguration, WokDataGridColumn } from './abstractions';

export default defineComponent({
    name: 'WokDataGridCellStatus',

    props: {
        label: {
            type: String,
            default: ''
        },
        status: {
            type: String,
            default: ''
        },
        statusLabel: {
            type: String,
            default: undefined
        },
        tooltip: {
            type: String,
            default: undefined
        },
        display: {
            type: String,
            default: 'auto',
            validator: (v: string) => v == '' || /(show|hide|auto|ui|report)/.test(v)
        }
    },

    setup(props, context) {

        // Inject table configuration and other data needed by this cell.
        const cfg = inject<WokDataGridConfiguration>('wokDataGridConfiguration');
        const rowProps = inject('wokDataGridRowProps') as { item: any };
        const item = computed(() => rowProps.item.item);
        const row = computed(() => rowProps.item.row);
        const index = computed(() => rowProps.item.index);

        // The first cell of every column is responsible for updating the
        // global table configuration.

        if (cfg && row.value == 1) {
            if (cfg.update) {
                cfg.update = false;
                cfg.columns = [];
            }

            const cell = reactive<WokDataGridColumn>({
                index: cfg.columns.length,
                label: '',
                align: 'left',
                display: 'ui',
                headerSpan: 1,
                dataType: '',
                dataPrecision: 0,
                dataName: null,
                dataIndex: null,
                dataFormat: null,
                dataAggregate: null
            });

            cfg.columns.push(cell);

            watchEffect(() => {
                cell.label = props.label;
                cell.display = props.display == 'auto' ? (props.statusLabel != null ? 'show' : 'ui') : props.display;
            });
        }

        return {
            item,
            index,
            row
        }
    }
})
